import {
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT_REQUEST,
  AUTH_LOGOUT_SUCCESS,
  AUTH_LOGOUT_FAILURE,
} from '../actions/auth-actions';
import {
  PHONE_AUTH_SUBMIT_REQUEST,
  PHONE_AUTH_SUBMIT_SUCCESS,
  PHONE_AUTH_SUBMIT_FAILURE,
  PHONE_AUTH_VERIFY_REQUEST,
  PHONE_AUTH_VERIFY_SUCCESS,
  PHONE_AUTH_VERIFY_FAILURE,
  PHONE_AUTH_CODE_RESEND_REQUEST,
  PHONE_AUTH_CODE_RESEND_SUCCESS,
  PHONE_AUTH_CODE_RESEND_FAILURE,
  PHONE_AUTH_SUBMIT_CAPTCHA_FAILURE,
  PHONE_AUTH_SUBMIT_CAPTCHA_BLOCK,
  PHONE_AUTH_CODE_RESEND_CAPTCHA_FAILURE,
  PHONE_AUTH_CODE_RESEND_CAPTCHA_BLOCK,
} from '../actions/phone-auth';

const initialState = {
  authenticated: false,
  error: '',
  loading: false,
  logoutLoading: false,
  pinSent: false,
  requireHumanInput: false,
  blockLogin: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case AUTH_LOGIN_SUCCESS:
    case PHONE_AUTH_VERIFY_SUCCESS:
      return {
        ...state,
        authenticated: true,
        loading: false,
        error: '',
        pinSent: false,
        requireHumanInput: false,
        blockLogin: false,
      };
    case AUTH_LOGIN_FAILURE:
      return {
        ...state,
        authenticated: false,
        loading: false,
        error: action.error,
      };
    case AUTH_LOGOUT_REQUEST:
      return {
        ...state,
        logoutLoading: true,
        error: '',
      };
    case AUTH_LOGOUT_SUCCESS:
      return {
        ...state,
        authenticated: false,
        logoutLoading: false,
        error: '',
      };
    case AUTH_LOGOUT_FAILURE:
      return {
        ...state,
        logoutLoading: false,
        error: action.error,
      };
    case PHONE_AUTH_SUBMIT_REQUEST:
    case PHONE_AUTH_VERIFY_REQUEST:
    case PHONE_AUTH_CODE_RESEND_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        pinSent: false,
      };
    case PHONE_AUTH_SUBMIT_SUCCESS:
    case PHONE_AUTH_CODE_RESEND_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        pinSent: true,
        requireHumanInput: false,
        blockLogin: false,
      };
    case PHONE_AUTH_SUBMIT_FAILURE:
    case PHONE_AUTH_VERIFY_FAILURE:
    case PHONE_AUTH_CODE_RESEND_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case PHONE_AUTH_SUBMIT_CAPTCHA_FAILURE:
    case PHONE_AUTH_CODE_RESEND_CAPTCHA_FAILURE:
      return {
        ...state,
        loading: false,
        requireHumanInput: true,
      };
    case PHONE_AUTH_SUBMIT_CAPTCHA_BLOCK:
    case PHONE_AUTH_CODE_RESEND_CAPTCHA_BLOCK:
      return {
        ...state,
        loading: false,
        error: 'Could not verify user authenticity',
        requireHumanInput: false,
        blockLogin: true,
      };
    default:
      return state;
  }
};

export default authReducer;
